import { Component, OnInit } from '@angular/core';
import { SecAdminUserService } from '../../services/sec-admin-user.service';
import { ISecAdminUser } from "../../interfaces/sec-admin-user";
import { ConfigurationService } from '../../services/configuration.service';
import { IBranding } from '../../interfaces/branding';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styles: [],
    standalone: false
})
export class HeaderComponent implements OnInit {
  public isNavbarCollapsed: boolean = true;
  public isLoggedIn: boolean = false;
  public displayName: string;
  public errorMessage: string;
  public branding: IBranding;

  constructor(private readonly secAdminUserService: SecAdminUserService,
    private readonly configService: ConfigurationService) { }

  ngOnInit() {
    var currentUser = this.secAdminUserService.getCurrentUser();
    this.UpdateUserValues(currentUser);

    this.secAdminUserService.CurrentUser
      .subscribe(currentUser => {
        this.UpdateUserValues(currentUser);
      }, error => {
        this.errorMessage = error.message;
      });

    this.configService.getBranding()
      .subscribe(
        data => this.branding = data,
        error => this.errorMessage = error.message
      );
  }

  public toggleNavbar() {
    this.isNavbarCollapsed = !this.isNavbarCollapsed;
  }

  private UpdateUserValues(currentUser: ISecAdminUser) {
    if (currentUser) {
      this.isLoggedIn = true;
      this.displayName = currentUser.displayName;
    } else {
      this.isLoggedIn = false;
    }
  }
}
